const prefix = 'LIBRARY_MODIFIER_';

export const LIBRARY_MODIFIER_SUBMIT_FORM_CREATE_ALL_OUTLET = `${prefix}SUBMIT_FORM_CREATE_ALL_OUTLET`;

export const LIBRARY_MODIFIER_CANCEL_DELETE_MODIFIER = `${prefix}CANCEL_DELETE_MODIFIER`;

export const LIBRARY_MODIFIER_SHOW_DELETE_MODIFIER_MODAL = `${prefix}SHOW_DELETE_MODIFIER_MODAL`;

export const LIBRARY_MODIFIER_HIDE_DELETE_MODIFIER_MODAL = `${prefix}HIDE_DELETE_MODIFIER_MODAL`;

export const LIBRARY_MODIFIER_ASK_DELETE_MODIFIER = `${prefix}ASK_DELETE_MODIFIER`;

export const LIBRARY_MODIFIER_SET_DELETED_MODIFIER = `${prefix}SET_DELETED_MODIFIER`;

export const LIBRARY_MODIFIER_SUBMIT_FORM_CREATE = `${prefix}SUBMIT_FORM_CREATE`;

export const LIBRARY_MODIFIER_DELETE_MODIFIER = `${prefix}DELETE_MODIFIER`;

export const LIBRARY_MODIFIER_SUBMIT_FORM_UPDATE = `${prefix}SUBMIT_FORM_UPDATE`;

export const LIBRARY_MODIFIER_ON_CLICK_CANCEL = `${prefix}ON_CLICK_CANCEL`;

export const LIBRARY_MODIFIER_PAGE_REQUEST = `${prefix}PAGE_REQUEST`;

export const LIBRARY_MODIFIER_SET_OUTLETS = `${prefix}SET_OUTLETS`;

export const LIBRARY_MODIFIER_OUTLETS_REQUEST = `${prefix}OUTLETS_REQUEST`;

export const LIBRARY_MODIFIER_MODIFIERS_REQUEST = `${prefix}MODIFIERS_REQUEST`;

export const LIBRARY_MODIFIER_ON_CLICK_ROW = `${prefix}ON_CLICK_ROW`;

export const LIBRARY_MODIFIER_ON_CHANGE_OUTLET_IDS = `${prefix}ON_CHANGE_OUTLET_IDS`;

export const LIBRARY_MODIFIER_ON_CLICK_CREATE_MODIFIER = `${prefix}ON_CLICK_CREATE_MODIFIER`;

export const LIBRARY_MODIFIER_SET_MODIFIERS = `${prefix}SET_MODIFIERS`;

export const LIBRARY_MODIFIER_SET_MODIFIER_DETAIL = `${prefix}SET_MODIFIER_DETAIL`;

export const LIBRARY_MODIFIER_SET_CURRENT_PAGE = `${prefix}SET_CURRENT_PAGE`;

export const LIBRARY_MODIFIER_SET_TOTAL_PAGE = `${prefix}SET_TOTAL_PAGE`;

export const LIBRARY_MODIFIER_ON_CLICK_APPLY_SET_ITEM = `${prefix}_ON_CLICK_APPLY_SET_ITEM`;

export const LIBRARY_MODIFIER_SHOW_APPLY_SET_ITEM_MODAL = `${prefix}_SHOW_APPLY_SET_ITEM_MODAL`;

export const LIBRARY_MODIFIER_HIDE_APPLY_SET_ITEM_MODAL = `${prefix}_HIDE_APPLY_SET_ITEM_MODAL`;

export const LIBRARY_MODIFIER_CANCEL_APPLY_SET_ITEM = `${prefix}_CANCEL_APPLY_SET_ITEM`;

export const LIBRARY_MODIFIER_CONFIRM_APPLY_SET_ITEM = `${prefix}_CONFIRM_APPLY_SET_ITEM`;

export const LIBRARY_MODIFIER_APPLY_SET_ITEM_SET_ITEMS = `${prefix}_APPLY_SET_ITEM_SET_ITEMS`;

export const LIBRARY_MODIFIER_APPLY_SET_ITEM_SET_CURRENT_PAGE = `${prefix}_APPLY_SET_ITEM_SET_CURRENT_PAGE`;

export const LIBRARY_MODIFIER_APPLY_SET_ITEM_SET_TOTAL_PAGE = `${prefix}_APPLY_SET_ITEM_SET_TOTAL_PAGE`;

export const LIBRARY_MODIFIER_APPLY_SET_ITEM_FILL_FORM = `${prefix}_APPLY_SET_ITEM_FILL_FORM`;

export const LIBRARY_MODIFIER_APPLY_SET_ITEM_ITEMS_REQUEST = `${prefix}_APPLY_SET_ITEM_ITEMS_REQUEST`;

export const LIBRARY_MODIFIER_FILL_MODIFIER_FORM = `${prefix}_FILL_MODIFIER_FORM_FLOW`;

export const LIBRARY_MODIFIER_SHOW_MODIFIER_OPTIONS_MODAL = `${prefix}_SHOW_MODIFIER_OPTIONS_MODAL`;

export const LIBRARY_MODIFIER_HIDE_MODIFIER_OPTIONS_MODAL = `${prefix}_HIDE_MODIFIER_OPTIONS_MODAL`;

export const LIBRARY_MODIFIER_ON_CLICK_MANAGE_MODIFIER_OPTIONS = `${prefix}_ON_CLICK_MANAGE_MODIFIER_OPTIONS`;

export const LIBRARY_MODIFIER_ON_CANCEL_MANAGE_MODIFIER_OPTIONS = `${prefix}_ON_CANCEL_MANAGE_MODIFIER_OPTIONS`;

export const LIBRARY_MODIFIER_ON_CONFIRM_MANAGE_MODIFIER_OPTIONS = `${prefix}_ON_CONFIRM_MANAGE_MODIFIER_OPTIONS`;

export const LIBRARY_MODIFIER_EMPTY_MODIFIER_FORM = `${prefix}_EMPTY_MODIFIER_FORM`;

export const LIBRARY_MODIFIER_SET_PREVIOUS_MODIFIER_FORM = `${prefix}_SET_PREVIOUS_MODIFIER_FORM`;

export const LIBRARY_MODIFIER_OPEN_RIGHT_COLUMN = `${prefix}OPEN_RIGHT_COLUMN`;

export const LIBRARY_MODIFIER_CLOSE_RIGHT_COLUMN = `${prefix}CLOSE_RIGHT_COLUMN`;

export const LIBRARY_MODIFIER_IS_SUBMITTING_FORM = `${prefix}IS_SUBMITTING_FORM`;

export const LIBRARY_MODIFIER_SET_ALL_ITEM_CONFIRMATION_MODAL_OPEN = `${prefix}SET_ALL_ITEM_CONFIRMATION_MODAL_OPEN`;

export const LIBRARY_MODIFIER_SET_ALL_ITEM_CONFIRMATION_MODAL_CLOSE = `${prefix}SET_ALL_ITEM_CONFIRMATION_MODAL_CLOSE`;

export const LIBRARY_MODIFIER_GET_INGREDIENTS_LIST = `${prefix}GET_INGREDIENTS_LIST`;
export const LIBRARY_MODIFIER_SET_INGREDIENTS_LIST = `${prefix}SET_INGREDIENTS_LIST`;
export const LIBRARY_MODIFIER_FETCH_INGREDIENTS_LIST = `${prefix}FETCH_INGREDIENTS_LIST`;
export const LIBRARY_MODIFIER_SET_SUBSCRIPTION = `${prefix}SET_SUBSCRIPTION`;
export const LIBRARY_MODIFIER_SHOW_UNABLE_TO_SAVE_ALL_OUTLET_MODAL = `${prefix}_SHOW_UNABLE_TO_SAVE_ALL_OUTLET_MODAL`;
export const LIBRARY_MODIFIER_HIDE_UNABLE_TO_SAVE_ALL_OUTLET_MODAL = `${prefix}_HIDE_UNABLE_TO_SAVE_ALL_OUTLET_MODAL`;
